module.exports = __webpack_public_path__ + "static/img/logo42.3509b1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo42.png
// module id = 3AK3
// module chunks = 1